import { getApp, getApps, initializeApp } from 'firebase/app';

import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

export const firebaseApp = getApps().length ? getApp() : initializeApp(CONFIG.firebase);
